module.exports = __webpack_public_path__ + "static/media/bg-produce_mb.7595a84b.jpg";